export const docTypes = [
  {key: 'header', value: 'Header'},
  {key: 'text', value: 'Texte'},
]
